export default [
  {
    path: '/loans',
    name: 'Loans',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'Loans',
      crud: {
        pageTitle: 'app.loans.title',
        pageContent: () => import('App/loans/LoansCrudList.vue'),
        filterComponent: () => import('Support/components/crud/OnlySearchFilter.vue'),
        anyComponent: () => import('App/loans/LoansTerminatteButton.vue'),
        filterDialogComponent: () => import('App/loans/LoansFilter.vue'),
        anyComponent1: () => import('App/loans/components/LoansTotalList.vue'),
      },
    },
  },
];
